<template>
  <div class="dashboard">


    <div class="row no-print">
        <div class="flex xs12 sm12 lg12">
          <va-card >
           <p  style="font-size: 25px"> {{$t('dashboard.SistemaGestao')}}</p>
                    <hr>
          </va-card>
        </div>
    </div>

     <div class="row ">
      
        <div class="flex xs12 sm12 lg3 no-print">
          <va-card title="Pressed Button Gradients">
                <va-button v-on:click="currentTab = funcionarios.componet" :color="funcionarios.color" :style="funcionarios" > {{ $t('gestaopessoas.Funcionarios') }}</va-button>
                <va-button v-on:click="currentTab = professores.componet" :color="professores.color" :style="professores" > {{ $t('gestaopessoas.Professores') }}</va-button>
                <va-button v-on:click="currentTab = alunos.componet" :color="alunos.color" :style="alunos" > {{ $t('gestaopessoas.Alunos') }}</va-button>
          </va-card>
        </div>

        <div class="flex xs12 sm12 lg9">
          <va-card >
         
          <component 
           v-on:trocar_component="trocar_component"
           v-bind:is="currentTabComponent"
          ></component>
          </va-card>
        </div>
    </div>

  </div>
</template>

<script>
import funcionarios from './Funcionarios'
import professores from './Professores'
import alunos from './Alunos'
import matriculaaluno from './MatriculaAluno'
import financeiroaluno from './FinanceiroAluno'

export default {
  name: 'dashboard',
  components: {
   funcionarios,
   professores,
   alunos,
   matriculaaluno,
   financeiroaluno,

  },

  data () {
      return {
        funcionarios: {
          componet: 'funcionarios',
          color:'success',
          'width': '100%',
        }, 
        professores: {
           componet: 'professores',
          color:'success',
          'width': '100%',
        }, 
        alunos: {
           componet: 'alunos',
          color:'success',
          'width': '100%',
        },  

      currentTab: 'Funcionarios',
     
      }
    },

  computed: {
    currentTabComponent () {
      console.log(this.currentTab)
      return  this.currentTab.toLowerCase()

    }
  },

  methods: {

      trocar_component (value) {
    //  alert(value)
      this.currentTab = value
      
    }
    
 
  },
}
</script>

<style lang="scss">
@media print {
  .no-print{
  display: none;
  }
  .print {
  display:block;
  }
}
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
